import { Context } from '@nuxt/types'
import { InterfaceRequestLogging, InterfaceResponseLogging } from '@ustra/data/src/models/interface-model'
import { ApiResponse } from '@ustra/data/src/models/api-model'

/**
 * 인터페이스 연계 기능
 */
export class Interfaces {
  private context: Context

  constructor(context) {
    this.context = context
  }

  /**
   * 아웃 바운드 인터페이스 조회
   * @param id 인터페이스 아이디
   * @param type 인터페이스 유형
   */
  getOutboundInterface = (id: string, type: string = null) => {
    const interfaces = this.context.$ustra.definedStore.interfaces.interfaces

    if (!interfaces) {
      return null
    }

    return interfaces.find(i => i.id === id && i.direction === 'OUTBOUND' && (!type || i.type === type))
  }

  /**
   * 인바운드 인터페이스 조회
   * @param id 인터페이스 아이디
   * @param type 인터페이스 유형
   */
  getInboundInterface = (id: string, type: string = null) => {
    const interfaces = this.context.$ustra.definedStore.interfaces.interfaces

    if (!interfaces) {
      return null
    }

    return interfaces.find(i => i.id === id && i.direction === 'INBOUND' && (!type || i.type === type))
  }

  /**
   * 인터페이스 목록을 조회한다.
   */
  getInterfaces = () => {
    return this.context.$ustra.definedStore.interfaces.interfaces || []
  }

  /**
   * 인터페이스 정보를 조회한다.
   * @param id 아이디
   * @param version 버전
   */
  getInterfaceInfo = (id: string, version: string = '1.0') => {
    const interfaces = this.context.$ustra.definedStore.interfaces.interfaces

    if (!interfaces) {
      return null
    }

    return interfaces.find(i => i.id === id && i.version === version)
  }

  /**
   * 요청 인터페이스 로깅을 추가한다.
   * @param IfsInfo
   * @param ifsInfo
   */
  public async addRequestLogging(logginInfo: InterfaceRequestLogging) {
    const apiUrl = this.context.$ustra.env.appProp.nuxt.interfaces?.apiLogging?.reqLoggingUrl

    if (!apiUrl) {
      return
    }

    try {
      if (logginInfo.requestContent) {
        logginInfo.requestContent = typeof logginInfo.requestContent === 'string' ? logginInfo.requestContent : JSON.stringify(logginInfo.requestContent)
      }

      const result = await this.context.$ustra.api.call<ApiResponse<number>>({
        url: apiUrl,
        data: logginInfo,
      })

      return result.data.body
    } catch (e) {
      return null
    }
  }

  /**
   * 응답 로깅 정보 추가
   */
  public addResponseLogging(loggingData: InterfaceResponseLogging) {
    const apiUrl = this.context.$ustra.env.appProp.nuxt.interfaces?.apiLogging?.resLoggingUrl

    if (!apiUrl) {
      return
    }

    if (!loggingData.loggingId) {
      return
    }

    this.context.$ustra.api.call<ApiResponse<number>>({
      url: apiUrl,
      data: loggingData,
    })
  }
}
